import KendoNotification from './KendoNotification'
import KendoTooltip from './KendoTooltip'
import KendoPopupsInstaller from './kendo-popups-installer'

export { KendoNotification, KendoNotification as Notification, KendoTooltip, KendoTooltip as Tooltip, KendoPopupsInstaller, KendoPopupsInstaller as PopupsInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/index.js